import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryPromoProduct';
/** Renders an SVG icon. */
const SvgCategoryPromoProduct = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M27.372 28q-.46 0-.9-.163a31.3 31.3 0 0 0-10.498-2.139A31.2 31.2 0 0 0 5.54 27.832a2.6 2.6 0 0 1-.911.167c-1.1 0-2.093-.707-2.469-1.758a2.7 2.7 0 0 1-.069-1.618l1.654-4.993v-3.346c0-6.61 4.965-12.003 11.38-12.463v-.928c0-.493.391-.893.874-.893.484 0 .876.4.876.893v.927c6.414.46 11.379 5.854 11.379 12.463v3.346l1.654 4.99a2.7 2.7 0 0 1-.258 2.036A2.62 2.62 0 0 1 27.372 28m-11.373-4.086c3.81.11 7.539.867 11.085 2.25a.8.8 0 0 0 .285.05.88.88 0 0 0 .762-.448.9.9 0 0 0 .085-.676l-1.552-4.613a47.5 47.5 0 0 0-10.666-1.62 47.5 47.5 0 0 0-10.666 1.62L3.78 25.091a.9.9 0 0 0 .024.537.88.88 0 0 0 .824.587.8.8 0 0 0 .298-.055 33 33 0 0 1 11.048-2.246zM16 5.57c-5.792 0-10.503 4.805-10.503 10.712v2.311a49.3 49.3 0 0 1 10.472-1.523l.031-.001.04.001c3.507.126 7.027.64 10.464 1.523v-2.31C26.503 10.376 21.792 5.57 16 5.57"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.385 9.503a.75.75 0 0 1-.064 1.059L13.13 12.5l2.19 1.938a.75.75 0 0 1-.995 1.123l-2.823-2.5a.75.75 0 0 1 0-1.123l2.823-2.5a.75.75 0 0 1 1.06.065m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m16.604 13.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0"
      />
    </svg>
  );
};
SvgCategoryPromoProduct.displayName = displayName;
export default SvgCategoryPromoProduct;
